<template>
  <v-layout :class="['ypo-phone-number', hasError && 'ypo-phone-number--error']">
    <v-flex>
      <VuePhoneNumberInput v-model="localPhone"
                           :clearable="canClear"
                           :disabled="isDisabled"
                           @update="emitUpdatedValue"
                           color="#CA8F0C"
                           :no-example="!showExample"
                           error-color="#e34843"
                           valid-color="#007F6A"
                           :default-country-code="defaultCountryCode"/>
    </v-flex>
    <v-flex pl-1 v-if="showExtension" class="ypo-phone-number__extension">
      <v-text-field
          name="extensionNumber"
          placeholder="ext"
          hide-details
          @change="sendUpdateWithExtension"
          v-model="localExtension">
      </v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import { getCountryFromCallingCode } from "@/common/utils/phoneUtils";


export default {
  name: 'YpoPhoneNumber',
  components: {
    VuePhoneNumberInput,
  },
  props: {
    phone: {
      type: String,
      default: '',
    },
    countryCode: {
      type: String,
      default: '',
    },
    extension: {
      type: String,
      default: '',
    },
    showExtension: {
      type: Boolean,
      default: false,
    },
    showExample: {
      type: Boolean,
      default: false,
    },
    canClear: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localPhone: '',
      localCountryCode: '',
      localExtension: '',
      hasError: false,
      phoneData: {},
    };
  },
  created() {
    this.localPhone = this.phone || '';
    this.localCountryCode = this.countryCode || '';
    this.localExtension = this.extension || '';
  },
  computed: {
    defaultCountryCode() {
      return this.localCountryCode.length ? getCountryFromCallingCode(this.localCountryCode) : 'US';
    },
  },
  methods: {
    sendUpdateWithExtension() {
      this.phoneData.extension = this.localExtension;
      this.$emit('update', this.phoneData);
    },
    emitUpdatedValue(data) {
      this.hasError = !data.isValid;
      if (!data.phoneNumber) {
        this.localExtension = '';
      }
      this.phoneData = {
        phone: data.phoneNumber || '',
        countryCode: data.countryCallingCode || '',
        extension: this.localExtension,
        isInvalid: !data.isValid && !!data.phoneNumber,
      };
      this.$emit('update', this.phoneData);
    },
  },
};
</script>
<style lang="scss">
@import "../../common/styles/_colors.scss";

.ypo-phone-number {
  display: flex;

  &__extension {
    width: 40px;

    .v-input__control {
      padding-top: 7px;
    }
  }

  .input-tel__input {
    border-top: none;
    border-right: none;
    border-bottom-right-radius: 0 !important;
    border-left-color: $ypo-light-medium-gray !important;
    background-color: transparent !important;
  }

  .country-selector__input {
    border-top: none;
    border-left: none;
    border-top-right-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    background-color: transparent !important;
  }

  .select-country-container {
    width: 90px !important;
    max-width: 90px !important;
    min-width: 90px !important;

    .country-selector__input {
      padding: 15px 5px 0 35px !important;
    }
  }

  &--error {
    .input-tel__input {
      color: $ypo-error-red !important;
    }
  }
}
</style>
